// AIDEV-NOTE: Handle both Vite build-time and Node runtime contexts
const VERCEL_URL =
    typeof __VITE_VERCEL_URL__ !== "undefined"
        ? __VITE_VERCEL_URL__
        : import.meta.env.VERCEL_URL || "";

export const SERVER_URL = VERCEL_URL
    ? "https://" + VERCEL_URL
    : typeof window !== "undefined"
      ? window.location.origin
      : import.meta.env.SERVER_URL;
export const API_URL = VERCEL_URL
    ? "https://" + VERCEL_URL + "/api"
    : SERVER_URL
      ? SERVER_URL + "/api"
      : "https://staging.ifscompanion.org/api";

export const IS_PRODUCTION =
    typeof window !== "undefined" && window.location.hostname.includes("app");

// AIDEV-NOTE: Handle both Vite and Node runtime contexts for analytics flag
export const ENABLE_ANALYTICS =
    (typeof import.meta !== "undefined" && import.meta.env?.PROD) || false;
